<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Course Offering Instructor Import</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete rounded :items="ay_list" v-model="ay" item-text="ay" item-value="id"
                        label="Academic Year" dense outlined placeholder="Select Academic Year"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row justify="center" align="center" v-if="ay!=null">
                <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                    <v-file-input placeholder="CSV of Course Offering Instructor" prepend-icon="mdi-file"
                        label="Course Offering Instructor Data" rounded dense flat outlined show-size
                        v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                    <a
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/Import_course_offering_instructor.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
                            class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                            Download import CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-col>
            </v-row>

            <v-row justify="center" align="center">
                <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
            </v-row>
        </v-card>
        <v-card class="box" v-if="this.show_table">
            <v-row justify="center" align="center">
                <v-col cols="12" sm="12" md="12" v-if="load==true">
                    <template v-if="load==true">
                        <v-data-table :headers="headers" :items="statuslist" sort-by class="elevation-1 mytable" dense
                            :search="search" :loading="output_load"></v-data-table>
                    </template>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="show_scuuess_table">
                    <template v-if="show_scuuess_table">
                        <v-data-table :headers="success_table_headers" :items="success_list" sort-by
                            class="elevation-1 mytable" dense :search="search" :loading="output_load"></v-data-table>
                    </template>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="present_table">
                    <template v-if="present_table">
                        <v-data-table :headers="present_table_headers" :items="already_present_list" sort-by
                            class="elevation-1 mytable" dense :search="search" :loading="output_load"></v-data-table>
                    </template>
                </v-col>
            </v-row>
        </v-card>



    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
        /*
      Defines the data used by the component
    */
        data() {
            return {
                ay_list: null,
                ay: null,
                show_scuuess_table:false,
                success_list:[],
                already_present_list:[],
                file: null,
                statuslist: "",
                // extraBreadcrumbItems: [
                   

                // ],
                // breadcrumbClass: "breadcrumb-style1",
                load: false,
                loading3: false,
                present_table:false,
                show_table:false,
                search: "",
                headers: [
                    { text: "Sr.NO", value: "count",sortable: true },
                    { text: "Field", value: "column",sortable: true },
                    { text: "Status", value: "status",sortable: true },
                ],
                present_table_headers:[
                     { text: "Sr.NO", value: "count",sortable: true },
                    { text: "Instructor", value: "instructor",sortable: true },
                    { text: "Division", value: "division" ,sortable: true},
                    { text: "Standard", value: "standard",sortable: true },
                    { text: "Course", value: "course",sortable: true },
                    { text: "Status", value: "status",sortable: true },
                ],
               success_table_headers:[
                     { text: "Sr.NO", value: "count" ,sortable: true},
                    { text: "Instructor", value: "instructor",sortable: true },
                    { text: "Division", value: "division" ,sortable: true},
                    { text: "Standard", value: "standard" ,sortable: true},
                    { text: "Course", value: "course" ,sortable: true},
                    { text: "Status", value: "status" ,sortable: true},
                ],
                output_load: false,
            };
        },
         mounted() {
            axios
                .post("/InstallmentStructureDetails/importLearnerSelectionHome")
                .then((res) => {
                    this.ay_list = res.data.ay_list;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => {});
        },
        methods: {
            submitFile() {
                if (this.file == null) {
                    alert("Please select the file!");
                } else {
                    this.output_load = true;
                    let formData = new FormData();
                    //console.log(this.file.size);
                    formData.append("file", this.file);
                    formData.append("ay", this.ay);
                    //console.log(formData)
                    axios
                        .post("Examination/importCourseOfferingInstructor", formData, { 
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.msg == "200") {
                                this.show_table=true
                                if(res.data.failstatuslist.length > 0){
                                   // alert("ifff")
                                    this.statuslist = res.data.failstatuslist;
                                     this.load = true;
                                }
                                if(res.data.success_status_list.length > 0){
                                  //  alert("if----2222")
                                        this.success_list=res.data.success_status_list
                                         this.show_scuuess_table = true
                                }if(res.data.already_present_list.length > 0){
                                    this.already_present_list=res.data.already_present_list
                                     this.present_table = true
                                }
                            }
                        })
                        .catch(function () {
                            console.log("FAILURE!!");
                        })
                        .finally(() => {
                            this.output_load = false;
                        });
                }

                //     }
            },

            /*
        Handles a change on the file upload
      */
        },
    };
</script>
<style scoped>
    .downbtn {
        float: right;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
